import { createSlice } from '@reduxjs/toolkit';
import { getAllYoutubeShorts } from '../api/youtubeShorts';

export const youtubeVideoShortSlice = createSlice({
  name: 'youtubeShorts',
  initialState: {
    loading: false,
    error: {},
    shorts: {},
  },
  reducers: {
    clearYoutubeShortError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    [getAllYoutubeShorts.pending]: (state) => {
      state.loading = true;
    },
    [getAllYoutubeShorts.fulfilled]: (state, action) => {
      state.loading = false;
      state.shorts = action.payload;
      state.error = {};
    },
    [getAllYoutubeShorts.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearYoutubeShortError } = youtubeVideoShortSlice.actions;

export default youtubeVideoShortSlice.reducer;
